import { render } from "./PlayerRankings.vue?vue&type=template&id=163d59c8"
import script from "./PlayerRankings.vue?vue&type=script&lang=ts"
export * from "./PlayerRankings.vue?vue&type=script&lang=ts"

import "./PlayerRankings.vue?vue&type=style&index=0&id=163d59c8&lang=scss"
script.render = render

export default script